import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from './constants';

@Injectable()
export class ProvidersService {
  private apiUrl = this.appConfig.API_URL_PROD;
  private apiUrWeb = this.appConfig.API_URL_WEB;
  private apiUrlVal = this.appConfig.API_URL_Validacion;
  private apiUrlSync = this.appConfig.API_URL_Sincronizacion;
  private apiUrlServ = this.appConfig.API_URL_POServicios;
  private apiUrlCharge = this.appConfig.API_URL_Carga;
  private apiNotaCredito = this.appConfig.API_URL_NotaCredito;
  private apiConsignacion = this.appConfig.API_URL_Consignacion;
  private apiYii = this.appConfig.API_URL_Yii;
  private apiPathWeb = this.appConfig.PATH_URL_WEB;

  private headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

  constructor(public http: HttpClient, private appConfig: AppConfig) {

  }

  createHeader(tmpToken : any ) {

    let token = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    this.headers = {headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
      'token': 'G13xTfsdf234TVsd23513ffdgFdf2352'
    })};// , 'token': token
  }

  /*createHeader(token) {
    this.headers = {headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    })};// , 'token': token
  }*/

  getMessages(provider, userId, token){
    this.createHeader(token);
    //const headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'NotificacionesProveedor/'+provider, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  newProvider(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrWeb+'Proveedores', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getProviders(token) {
    this.createHeader(token);

    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Proveedores', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getProvidersNum(token, sociedad = null) {
    this.createHeader(token);

    let url_cnn = this.apiUrWeb+'Proveedores/GetNumerosProveedores';
    if(sociedad != null){
      url_cnn = this.apiUrWeb+'Proveedores/GetNumerosProveedores?NumSociedad='+sociedad;
    }

    return new Promise((resolve, reject) => {
      this.http.get(url_cnn, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  getProviderNum(token, numProveedro ) {
    this.createHeader(token);

    let url_cnn = this.apiUrWeb+'Proveedores/' + numProveedro + '/Detalle';

    return new Promise((resolve, reject) => {
      this.http.get(url_cnn, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getProvider(id, token) {
    this.createHeader(token);

    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Proveedores/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  updateProvider(id, params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrWeb+'Proveedores/'+id, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  uploadCfdi(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlCharge+'CargaCFDI', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  uploadPdfForeign(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlCharge+'CargarPDFExtranjero', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  uploadCfdiComplement(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlCharge+'CargaCFDICompPago', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  uploadCreditNote(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiNotaCredito+'infoXml', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }



  uploadCfdiConsignment(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiYii+'consignacion/cargacfdiconsignacion', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  searchOC(oc, society, folio, prov, type, userId, token) {
    this.createHeader(token);
    let pfolio = '';
    let pprov = '';
    let typeOr = '';
    if(prov){
      pprov = '&noProveedor='+prov;
    }

    if(folio){
      pfolio = '&folio='+folio;
    }

    if(type){
      typeOr = '&TipoOrden='+type;
    }
    let ordenes = (oc)? '&OrdenCompra='+oc: '';
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlSync+'OrdenesCompra/GetOrdenCompra?IdUsuario='+userId+ ordenes+pfolio+pprov+'&sociedad='+society+typeOr, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  searchHistoryComplePayments(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/ObtenerPagosConComplemento', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  exportToExcel(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/ObtenerPagosConComplementoExcel', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  invoicesHistoryComplePayments(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/ObtenerFacturasDePagosConComplemento', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  searchComplePayments(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/ObtenerPagosCompensados', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  searchComplePaymentsDocs(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/ObtenerDocumentosDePago', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  searchOrdersService(userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlServ+'AprobacionPO/IdUsuario='+userId, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  historyOrdersService(token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlServ+'HistoricoAprobacionPO', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  apporveService(id, oc, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'AprobacionPO?id='+id+'&ordencompra='+oc, {data: true}, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  rejectService(id, comment, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'AprobacionPO?id='+id+'&comentario='+comment, {data: true}, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  getCloseOrders(params, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {

      let GetParams = 'IdUsuario='+params.usuario;
      if(params.FechaInicio || params.FechaInicio != null){
        GetParams += '&fechaInicio='+params.FechaInicio;
      }
      if(params.FechaFin || params.FechaFin !=null){
        GetParams += '&fechaFin='+params.FechaFin;
      }
      GetParams += '&NumSociedad='+params.Sociedad;
      GetParams += params.GuidFactura  ? '&GuidFactura=' + params.GuidFactura : "";
      GetParams += params.Planta  ? '&Planta=' + params.Planta : "";

      if(params.Proveedor){
        GetParams += '&proveedores='+params.Proveedor;
      }

      this.http.get(this.apiUrWeb+'StatusOrdenesCerradas?'+GetParams , this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getCloseOrdersReport(params, token) {
    this.createHeader(token);

    this.headers = {headers: new HttpHeaders({
      'tokenc': 'G13xTfsdf234TVsd23513ffdgFdf2352'
    })};

    return new Promise((resolve, reject) => {
      this.http.post( this.apiYii +'reportes/conciliacion', params/*, this.headers*/)
        .subscribe(data => {
          resolve(data);
        }, (err) => {
          reject(err);
        });
    });
  }

  getCloseOrder(id, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'StatusOrdenesCerradas/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getOpenOrders(userId, token) {

    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'StatusOrdenesAbiertas?IdUsuario='+userId, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getOpenOrdersList(params, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {

      let GetParams = 'IdUsuario='+params.usuario;
      GetParams += (params.FechaInicio ?  '&fechaInicio='+params.FechaInicio : "" );
      GetParams += (params.FechaFin   ?   '&fechaFin='+params.FechaFin: "" );
      GetParams += (params.Sociedad  ?  '&NumSociedad='+params.Sociedad: "" );
      GetParams += ( params.GuidFactura  ? '&GuidFactura=' + params.GuidFactura : "");
      GetParams += (params.Planta  ? '&Planta=' + params.Planta : "");

      if(params.Proveedor){
        GetParams += '&proveedores='+params.Proveedor;
      }

      this.http.get(this.apiUrWeb+'StatusOrdenesAbiertas?'+GetParams , this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getOpenOrder(id, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'StatusOrdenesAbiertas/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getSociedades(userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Usuarios/'+userId+'/Sociedades', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getPlantas(userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Usuarios/'+userId+'/Plantas', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  searchConsignments(params, token) {
    //this.createHeader(token);

    let headers = {headers: new HttpHeaders({
      'token': 'zMw7=hMTM%xEjjFJaw$'
    })};

    return new Promise((resolve, reject) => {
      this.http.get(this.apiYii+'consignacion?'+params, headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
      });


  }



  addCreditNote(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiNotaCredito+'NotasCredito', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  addManualPayment(params, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post( this.apiNotaCredito + 'GastoManual', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getProviderDifference(id, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Proveedores/'+id+'/DiferenciaImportes', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  sendDifferenceProv(id, params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrWeb+'Proveedores/'+id+'/DiferenciaImportes', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  sendNewUser(id, params, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {

      this.http.post(this.apiUrWeb + 'Proveedores/' + id + '/NuevoUsuario', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  sendCompanies(id, params, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrWeb + 'Proveedores/' + id + '/Sociedades', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  searchRetentions(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'RetencionesProveedor?NumeroProveedor='+params.NumeroProveedor+'&IdSociedad='+params.IdSociedad, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  assignRetentions(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'AdministrarRetencionesProveedor?IdRetencion='+params.IdRetencion+'&IdProveedor='+params.IdProveedor, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getCostCenter(token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlServ+'AutorizadorPorClave?esCentroDeCosto=true', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getCostCenterIntern(token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlServ+'AutorizadorPorClave?esCentroDeCosto=false', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  costCenterAddClave(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'AutorizadorPorClave/PostCrearClave', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  costCenterAssignClave(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'AutorizadorPorClave/PostAsignarClave', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  costCenterRemoveClave(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'AutorizadorPorClave/PostRemoverAutorizador', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  getProvidersActive(userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+'user/'+userId+'/providers-active', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  addContactProvider(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'user/'+userId+'/providers/'+id+'/contact', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  editContactProvider(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrl+'user/'+userId+'/providers/'+id+'/contact', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  deleteContactProvider(id, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.delete(this.apiUrl+'user/'+userId+'/providers/'+id+'/contact', this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  addBankProvider(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'user/'+userId+'/providers/'+id+'/bank', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

 editBankProvider(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrl+'user/'+userId+'/providers/'+id+'/bank', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  deleteBankProvider(id, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.delete(this.apiUrl+'user/'+userId+'/providers/'+id+'/bank', this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  addUserProvider(id, params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'user/'+userId+'/providers/'+id+'/user', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  reportPayments(params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/ObtenerReporte', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  reportBills(params, userId, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync + 'ReporteFacturas/ObtenerReporte', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  downloadReportPayments(params, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/ObtenerReporteExcel', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  downloadHistoryComplement(id, userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlSync+'PagosCompensados/DescargarComplementoPago?IdPagoCompensado='+id, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  downloadFiles(id, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrlCharge+'ArchivosCFDI?UUID='+id, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getInfoProviderFirstSession(userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiPathWeb+'api/Usuarios/'+userId+'/GetDatosGenerales', this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  descargaMasiva(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {

      this.http.post(this.apiUrlCharge+'DescargaMasiva', params, this.headers)
      // this.http.post(api, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  sendReminder(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/EnviarRecordatoriosDePago', params, this.headers)
      // this.http.post(api, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
      })
  }
  sendReminderDirect(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/EnviarRecordatoriosDePagoDirecto', params, this.headers)
      // this.http.post(api, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
      })
  }

  updateDataProvider(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.put(this.apiUrWeb+'Proveedores/'+params.id, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  postBulkLoad(params, token){
    let url = this.apiYii+"masiva/pagos";

    //this.createHeader(token);
    // 'application/x-www-form-urlencoded'
    let headers = {headers: new HttpHeaders({ 'Content-Type': 'application/json' })};

    return new Promise((resolve, reject) => {
      this.http.post(url, params, headers)
      // this.http.post(api, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
      });
  }

  getBulkLoad(params, toke){
    let proveedores = (params.Proveedores)?'&Proveedores='+ params.Proveedores: '';
    let url = this.apiYii+"masiva/cargamasivacpagos?fechaInicio="+params.FechaInicio+"&fechaFin="+params.FechaFin+proveedores;
    //this.createHeader(token);
    let headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

    return new Promise((resolve, reject) => {
      this.http.get(url, headers)
      // this.http.post(api, params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
      });
  }

  getManualPayment(params, token) {
    this.createHeader(token);
    //const headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

    return new Promise((resolve, reject) => {
      let GetParams = 'fechaInicio='+params.FechaInicio;
      GetParams += '&fechaFin='+params.FechaFin;
      GetParams += '&NumSociedad='+params.Sociedad;

      if(params.Proveedor){
        GetParams += '&proveedores='+params.Proveedor;
      }

      if(params.GuidFactura){
        GetParams += '&GuidFactura='+params.GuidFactura;
      }

      this.http.get(this.apiUrWeb+'StatusGastosManuales?'+GetParams , this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getCreditList(params, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      let GetParams = 'IdUsuario='+params.usuario;
      GetParams += '&fechaInicio='+params.FechaInicio;
      GetParams += '&fechaFin='+params.FechaFin;
      GetParams += '&NumSociedad='+params.Sociedad;

      if(params.Proveedor){
        GetParams += '&proveedores='+params.Proveedor;
      }

      this.http.get(this.apiUrWeb+'StatusNotasCredito?'+GetParams , this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  autorizaPagos(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/AutorizarPagoCompensadoConComplemento', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  borrarComplemento(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlSync+'PagosCompensados/BorrarPagoCompensadoConComplemento', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });

  }

  getCentroCostoSociedad(userId, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Usuarios/'+userId+'/Sociedades', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  getUserAuthorizer(token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'Usuarios?Filter=IdPerfil==4', this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getServicePending(params, token){

    this.createHeader(token);
    return new Promise((resolve, reject) => {
      let GetParams = 'fechaInicio='+params.FechaInicio;
      GetParams += '&fechaFin='+params.FechaFin;
      GetParams += '&NumSociedad='+params.Sociedad;
      GetParams += '&IdUsuario='+params.IdUsuario;

      if(params.Proveedor){
        GetParams += '&Proveedores='+params.Proveedor;
      }

      var url = "";
      if( params.idTipo == "1"){
        url = this.apiUrWeb+'StatusOrdenesCerradasPendientes?'+GetParams ;
      }
      else if( params.idTipo == "2"){
        url = this.apiUrWeb+'StatusOrdenesAbiertasPendientes?'+GetParams;
      }
      else if( params.idTipo == "3"){
          url =this.apiUrWeb+'StatusOrdenesServicioPendientes?'+GetParams;
      }

      this.http.get( url , this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }


  approveInvoice(params, token){
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrWeb+'AutorizacionServicios', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });

  }

  deleteCenterCost(params, token){
    console.info(params);
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlServ+'AutorizadorPorClave/PostBorrarAutorizador', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getReportConsigment(params, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      let GetParams = 'IdUsuario='+params.usuario;
      GetParams += '&fechaInicio='+params.FechaInicio;
      GetParams += '&fechaFin='+params.FechaFin;
      GetParams += '&NumSociedad='+params.Sociedad;
      GetParams += params.Planta  ? '&Planta=' + params.Planta : "";

      if(params.Proveedor){
        GetParams += '&proveedores='+params.Proveedor;
      }

      this.http.get(this.apiUrWeb+'StatusConsignacion?'+GetParams , this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getReportConsigmentYii(params, token) {

    if(params.Sociedad == undefined){
      params.Sociedad = null;
    }

    this.createHeader(token);
    return new Promise((resolve, reject) => {
      let GetParams = 'IdUsuario='+params.usuario;
      GetParams += '&fechaInicio='+params.FechaInicio;
      GetParams += '&fechaFin='+params.FechaFin;
      GetParams += '&NumSociedad='+params.Sociedad;
      GetParams += '&uuid='+params.uuid;
      GetParams += params.Planta  ? '&Planta=' + params.Planta : "";

      if(params.Proveedor){
        GetParams += '&proveedores='+params.Proveedor;
      }

      this.http.get(this.apiYii+'consignacion/status_consignacion?'+GetParams , this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  getConsignment(id, token) {
    this.createHeader(token);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrWeb+'StatusConsignacion/'+id, this.headers).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }
}

